export default {"src":"/_next/static/media/send-money.45caa296.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};